import type { IClient } from "@/types/users-clients";
import type { IInspector } from "@/types/users-inspectors";
import type { IAdmin } from "@/types/users-admins";
import type { IContractor } from "@/types/users-contractors";
import type { ILoanOfficer } from "@/types/users-loan-officers";
import type { IProjectManager } from "@/types/users-project-managers";
import type { ILoanProcessor } from "@/types/users-loan-processors";
import type { Request } from "@/types/requests";

export type IUser = {
  id: number;
  userName: string;
  fullName: string;
  email: string;
  phone: string;
  role: UserRole;
  profilePicturePath: string;
  onboardingStatus: UserOnboardingStatus;
  status: UserStatus;
  pendingRequests?: Request[];
  enabled?: boolean;
};

export enum UserRole {
  Admin = "ADMIN",
  Contractor = "CONTRACTOR",
  Inspector = "INSPECTOR",
  Client = "CLIENT",
  SuperAdmin = "SUPERADMIN",
  LoanOfficer = "LOAN_OFFICER",
  LoanProcessor = "LOAN_PROCESSOR",
  ProjectManager = "PROJECT_MANAGER",
}

export enum UserStatus {
  Active = "Active",
  InvitationExpired = "Invitation Expired",
  Invited = "Invited",
  Inactive = "Inactive",
}

export enum UserOnboardingStatus {
  NotStarted = "ONBOARDING_NOT_STARTED",
  AccountClaimed = "ACCOUNT_CLAIMED",
  DetailsProvided = "DETAILS_PROVIDED",
}

export type IUserProfile =
  | IClient
  | IInspector
  | IAdmin
  | IContractor
  | IProjectManager
  | ILoanProcessor
  | ILoanOfficer;

export enum UserLoadingStatus {
  NotStarted = "NOT_STARTED",
  Pending = "PENDING",
  Loading = "LOADING",
  Loaded = "LOADED",
}
